import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Student } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./StatusForm.form";
import { withEmptyOption } from "../../../../utils";

const studentController = new Student();

export function StatusForm(props) {
  const { onClose, onReload, student } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        studentController.updateStudentStatus(
          accessToken,
          student.id,
          formValue
        );
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });
  
  const statusOptions = [
    { key: "1", value: "1", text: "Activo" },
    { key: "2", value: "2", text: "Aprobado" },
    { key: "3", value: "3", text: "Desaprobado" },
    { key: "4", value: "4", text: "Retirado" },
    { key: "5", value: "5", text: "Inactivo" },
  ];

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Select
        className="edunova-select"
        name="status"
        label="Estado"
        placeholder="Selecciona un estado"
        clearable
        options={withEmptyOption(statusOptions, "Selecciona un estado")}
        onChange={(e, { value }) => formik.setFieldValue("status", value)}
        value={formik.values.status}
        error={formik.errors.status}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Actualizar estado
      </Form.Button>
    </Form>
  );
}
